import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Constants from '../app.constants';
import { CacheService } from 'ionic-cache';
import { TTL_RECOMMENDATION } from '../app.constants';
import { Raccomandazione, RaccomandazioneResponse } from '../models/raccomandazione';
import { EventoRaccomandazione, EventoRaccomandazioneResponse, UserRaccomandazione } from '../models/evento-raccomandazione';
import { AuthService } from './auth.service';
import { AnalyticsService } from '../analytics.service';
import { ShareService } from './share.service';
import { Localizzazione } from '../models/localizzazione';
import { EventService } from './event.service';
import { PoiService } from './poi.service';
import { ItineraryService } from './itinerary.service';
import { Poi } from '../models/poi';
import { ElencoPoi } from '../models/elenco-poi';
import { UtilitiesService } from './utilities.service';
import { FavouriteService } from './favourite.service';
import { User } from './user/user';

@Injectable({
  providedIn: 'root'
})
export class RecommendationEngineService {

  //Tiene traccia se ho gia contattato il motore con l'utente in sessione attuale
  userJustAdded : UserRaccomandazione = null;

  constructor(
    private utilitiesService: UtilitiesService,
    private httpClient: HttpClient,
    private analyticsService: AnalyticsService,
    public auth: AuthService,
    private favouriteService: FavouriteService,
    private translateService: TranslateService
  ) {

    //console.log('RENGINE - INIT');
  }


  /**
   * 
   * @param raccomandazione 
   * Recupera le raccomandazioni
   */

  async getRecommended(raccomandazione: Raccomandazione) {

    /**
     * Recupera l'utente
     */
    let promiseUser = this.getUser().then( res => {
      console.log('RENGINE - getRecommended - User Logged');
    }, err => {
      console.log('RENGINE - getRecommended - User Guest');
    });
    let resultSuggested = await promiseUser;


    raccomandazione.platform = this.getUserAgent();


    //Se ho un utente salvato, lo recupero
    if ( !raccomandazione.user && this.userLogged && this.userLogged.userId ) {
      raccomandazione.user = this.userLogged.userId;
    }

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');


    let path = `${Constants.API_RECOMM_BASE_URL}${Constants.BASE_QUERIES}`;


    if ( raccomandazione.language ) {
      path += '&language=' + raccomandazione.language;
    }

    if ( raccomandazione.relativeDistanceLat && raccomandazione.relativeDistanceLon ) {
      path += '&latitude=' + raccomandazione.relativeDistanceLat + '&longitude=' + raccomandazione.relativeDistanceLon;
    }

    console.log('RENGINE - getRecommended - Query del motore');
    console.log(raccomandazione);

    //Se la lista di types è presente ma è vuota, allora la setto a NULL
    if ( raccomandazione.types && raccomandazione.types.length === 0 ) {
      raccomandazione.types = null;
    }

    raccomandazione.normalizeContent = true;
    raccomandazione.normalizeContext = true;
    raccomandazione.normalizeCollaborative = true;



    return new Promise((resolve, reject) => {

      this.httpClient.post(path, JSON.stringify(raccomandazione), {
        headers: headers
      }).subscribe( (res:any) => {
        let result;

        //In questa sezione dovrei andare ad inserire anche gli sponsorizzati
        if ( res.results ) {
          result = res.results;
        } else {
          console.error('RENGINE - getRecommended - Nessun risultato dal Motore');
        }

        if ( result )  {
          result.forEach( async (element: RaccomandazioneResponse, index) => {
            element.explanationCustom = [];

            Object.entries( element.explanation_list_code ).forEach( ([key,value]) => {

              //Mostriamo solo la motivazione al primo posto
              if ( value === 1 ) {
                element.explanationCustom.push(key);
              }
            });
            

            element.isSuggested = true;

            
            element.query = raccomandazione;
            element.rank = index + 1; //Aggiungo 1 perchè il rating parte da 1, mentre gli index partono da 0
          
            if ( element.type_element === Constants.POY_TYPE.EVENT.KEY ) {
              this.utilitiesService.estraiDateDaEvento( element.obj );
            }

            element.obj.indirizzoEsteso = this.utilitiesService.formatIndirizzoEsteso( element.obj );

            element.obj.isFavourite = await this.favouriteService.isFavorite(
                            element.obj.id,
                            element.obj.typeElement.key
                          );
          });

          if ( result.length < raccomandazione.num ) {
            console.error('Trovato meno elementi di quanto cercassi - Probabile DB sporco');
          }
        }

        //Recupero gli sponsorizzati e li aggiungo alla lista
        let sponsored;
        if ( res.sponsored ) {
          // La gestione degli sponsorizzati non prevede un'ordinamento 
          // per questo motivo li disordiniamo in modo preventivo
          // per evitare che vengano visualizzati sempre e solo gli stessi
          sponsored = res.sponsored.sort(() => Math.random() - 0.5)
          console.error('RENGINE - getRecommended - Trovati ' + sponsored.length + ' elementi');

          //Controllo che la lista non sia maggiore del limite massimo
          if ( sponsored.length > raccomandazione.maxSponsored ) {
            sponsored = sponsored.slice(0, raccomandazione.maxSponsored);
          }

          //Rimuovo dalla lista dei raccomandati, gli eventuali elementi che sono stati sponsorizzati, per evitare duplicati
          sponsored.forEach(element => {
            element.isSponsored = true;
            const index = result.findIndex(
              x => x.item === element.item
            );
            if ( index > -1 ) {
              result.splice(index, 1);
            }
          });

          //Inserisco gli sponsorizzati in testa ai raccomandati
          result.unshift( ...sponsored );

        } else {
          console.error('RENGINE - getRecommended - Nessuno sponsorizzato dal Motore');
        }


        //Verifico che il totale raggiunto non superi il limite impostato nella configurazione
        if ( result && result.length > raccomandazione.num ) {
          result = result.slice( 0 , raccomandazione.num);
        }

        resolve( result );
      },
      err => {
        console.error('RENGINE - getRecommended - Il Motore ha restituito un errore');

        console.error(err);
        reject(err);

      });

    });
  }




  

  //Torna TRUE nel caso di inserimento completato con successo, FALSE altrimenti
  public async addCustomView(idObject, raccomandationMethod? , raccomandationRank?, position? : Localizzazione) {

    if ( !Constants.RECOMM_ENABLED ) return false;


      console.log('RENGINE - Add Custom View - ' + idObject + ' - Sorgente:' + raccomandationMethod + '-' + raccomandationRank);

      let promiseUser = this.getUser().then( res => {
        console.log('RENGINE - addCustomView - getUser - then - SUCCESS');
        console.log(res);
      }, err => {
        console.log('RENGINE - addCustomView - getUser - then - ERROR');
        console.log(err);
      });
      let resultSuggested = await promiseUser;


      let platform = this.getUserAgent();

      let eventoRaccomandazione: EventoRaccomandazione = new EventoRaccomandazione(
        "view", 
        "user", null,
        "item", idObject, {
        "platform": platform,
      });


      //Se ho un utente in sessione allo lo posso inviare
      if ( this.userLogged && this.userLogged.userId ) {
        eventoRaccomandazione.user = this.userLogged;
        eventoRaccomandazione.entityId = this.userLogged.userId;
      }



    if (  position && position.indirizzo  ) {
      eventoRaccomandazione.properties.location = position.indirizzo;
    }

    /**
     * Votazione implicita
     */
    if ( raccomandationMethod && raccomandationRank ) {
      //Il Rank deve essere un numero, per questo motivo faccio il cast con il carattere +
      eventoRaccomandazione.properties.rank = +raccomandationRank;

      //Elenco degli algoritmi
      eventoRaccomandazione.properties.algorithms = [];
      // raccomandationMethod potrebbe essere un elenco di stringhe separate da ','
      // per questo motivo concateno l'array
      eventoRaccomandazione.properties.algorithms = eventoRaccomandazione.properties.algorithms.concat(raccomandationMethod.split(','));

      //Se l'array è vuoto, lo setto a NULL
      if ( eventoRaccomandazione.properties.algorithms.length === 0 ) {
        eventoRaccomandazione.properties.algorithms = null;
      }
    }

    console.log('Invio evento al Motore');
    console.log(eventoRaccomandazione);

    this.addEventToRE(eventoRaccomandazione).subscribe(
      (res: EventoRaccomandazioneResponse) => {
        if (res.eventId) {
          //console.log('RENGINE - Inserito nuovo evento al motore');
        } else {
          console.error("RENGINE - success - ADD VIEW KO. Message: " + res.message)
        }
      },
      err => {
        console.error("RENGINE - err - ADD VIEW KO. Message: " + err.message)
      }
    );
  }



  //Torna TRUE nel caso di inserimento completato con successo, FALSE altrimenti
  public async addDislikeEvent(objId) {

    if ( !Constants.RECOMM_ENABLED ) return false;

    console.log('RENGINE - Add Dislike ' + objId);

    let promiseUser = this.getUser();
    let resultSuggested = await promiseUser;

    let platform = this.getUserAgent();
    let userId = this.userLogged.userId;

    let eventoRaccomandazione: EventoRaccomandazione = new EventoRaccomandazione("dislike", "user", userId,
      "item", objId );
    

    this.addEventToRE(eventoRaccomandazione).subscribe(
      (res: EventoRaccomandazioneResponse) => {
        console.log(res);
        if (res.eventId) {
          console.log('Inserimento DISLIKE nel motore di raccomandazione completato');
          return true;
        } else {
          console.error("Errore durante l'inserimento dell'evento DISLIKE nel motore di raccomandazione. Message: " + res.message)
          return false;
        }
      },
      err => {
        console.log('Errore nel salvataggio');
        return false;
      }
    );

    return false;
  }



  //Torna TRUE nel caso di inserimento completato con successo, FALSE altrimenti
  public async addCustomRating(objId, rate, position?: Localizzazione) {

    if ( !Constants.RECOMM_ENABLED ) return false;

    console.log('RENGINE - Add Custom Rate - ' + objId + ' - ' + rate);

    let promiseUser = this.getUser();
    let resultSuggested = await promiseUser;

    let platform = this.getUserAgent();
    let userId = this.userLogged.userId;
    //let location = this.shareService.lastUserLocation.indirizzo;

    let eventoRaccomandazione: EventoRaccomandazione = new EventoRaccomandazione("rate", "user", userId,
      "item", objId, {
      "platform": platform,
    /*  "location": location,*/
      "rating": rate
    });
    if ( position ) {
      eventoRaccomandazione.properties.location = position.indirizzo;
    }

    this.addEventToRE(eventoRaccomandazione).subscribe(
      (res: EventoRaccomandazioneResponse) => {
        console.log(res);
        if (res.eventId) {
          console.log('Inserimento rating nel motore di raccomandazione completato');
          return true;
        } else {
          console.error("Errore durante l'inserimento del rating nel motore di raccomandazione. Message: " + res.message)
          return false;
        }
      },
      err => {
        console.log('Errore nel salvataggio');
        return false;
      }
    );

    return false;
  }



  addEventToRE(evento: EventoRaccomandazione) {

    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const path = `${Constants.API_RECOMM_BASE_URL}${Constants.BASE_EVENTS}?accessKey=${Constants.RECOMM_ACCESS_KEY}`;



    //Se l'evento è scatenato da un utente  (in questa release dovremmo avere solo di questi casi)
    //Se non ho ancora aggiunto utenti al motore, oppure è cambiato l'id di sessione (a seguito di un login)
    //Chiamo il motore per aggiungere una nuova entry ( tanto verrà appiattito nel tempo)

    // In caso di EVENTO user
    switch (evento.entityType) {
      case "user":
        if ( (evento.user && evento.user.userId ) &&
          (this.userJustAdded === null || 
          this.userJustAdded.userId != evento.user.userId ) ) {

            let eventoCreazioneUtente: EventoRaccomandazione = new EventoRaccomandazione(
              "$set", 
              "user", evento.user.userId);
              eventoCreazioneUtente.properties = {};

              if ( evento.user.gender ) {
                eventoCreazioneUtente.properties.gender = evento.user.gender;
              } else {
                eventoCreazioneUtente.properties.gender = 'n.d.';
              }
              if ( evento.user.age ) {
                eventoCreazioneUtente.properties.age = evento.user.age;
              } else {
                eventoCreazioneUtente.properties.age = 'n.d.';
              }
            

            this.httpClient.post(path, JSON.stringify(eventoCreazioneUtente), {
              headers: headers
            }).subscribe( res => {
              this.userJustAdded = evento.user;
              console.log('RENGINE - Add user to Engine');

            },
            err => {
              console.error('RENGINE - Add user to Engine');
            });
        }
        break;
    }
    

    //Salvataggio dell'evento
    console.log('RENGINE - Send Event to Engine');
    console.log( evento );
    return this.httpClient.post(path, JSON.stringify(evento), {
      headers: headers
    });
  }


   _calculateAge(birthday) { // birthday is a date
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  userLogged: UserRaccomandazione = null;
  public getUser() {

    return new Promise((resolve, reject) => {

      //console.log('RENGINE - getUser');

      let userId = null;

      if (this.auth.isAuthenticated()) {
        if (this.auth.user && this.auth.user.sub) {
          //console.log('RENGINE - getUser Utente loggato - con auth sub');

          if ( this.userLogged && 
              this.userLogged.userId === this.auth.user.sub ) {
            //console.log('RENGINE - getUser Utente sempre lo stesso');

            resolve( this.userLogged );
          } else {
            // Utente diverso - carico i metadati e lo ritorno
            //console.log('RENGINE - getUser Utente diverso');
            this.userLogged = new UserRaccomandazione();
            this.userLogged.userId = this.auth.user.sub;

            

            let path = Constants.API_BASE_URL + Constants.SOCIAL_AUTH_METADATA_BASE_URL;
            this.httpClient.get(path).subscribe(
               (res: any) => {
                 //console.log('RENGINE - getUser - Ho gli altri dati utente');

                 if ( res ) {
                   //Controllora la data di nascita
                   if ( res.birthday ) {

                    let age = this._calculateAge( new Date(res.birthday) );

                    if ( age < 18 ) {
                      this.userLogged.age = '<18';
                    } else if ( age < 30 ) {
                      this.userLogged.age = '18-30';
                    } else if ( age < 45 ) {
                      this.userLogged.age = '30-45';
                    } else if ( age < 60 ) {
                      this.userLogged.age = '45-60';
                    } else if ( age < 75 ) {
                      this.userLogged.age = '60-75';
                    } else  {
                      this.userLogged.age = '>75';
                    }

                   }

                   if ( res.gender ) {
                     if (res.gender.toLowerCase() === "male" ) {
                      this.userLogged.gender = "m";
                     } else if (res.gender.toLowerCase() === "female" ) {                      this.userLogged.gender = res.gender;
                      this.userLogged.gender = "f";
                    }
                  }
                 }

                resolve(this.userLogged);
              },
              err => {
                console.log('RENGINE - getUser - Errore nei metadati utente');
                this.userLogged = null;
                reject(null);
              }
            );
          }
  
  
        } else {

          //console.log('RENGINE - getUser Utente loggato - senza auth sub');

          if ( this.analyticsService.uuid ) {
            //console.log('RENGINE - getUser - con uuid');
  
            this.userLogged = new UserRaccomandazione();
            this.userLogged.userId = this.analyticsService.uuid;
  
            resolve( this.userLogged  );
          } else {
            //console.log('RENGINE - getUser - SENZA uuid');
            this.userLogged = null;

            reject();
          }
        }
  
      } else {
        console.log('RENGINE - getUser Utente non loggato');

        if ( this.analyticsService.uuid ) {
          //console.log('RENGINE - getUser - con uuid');

          this.userLogged = new UserRaccomandazione();
          this.userLogged.userId = this.analyticsService.uuid;

          resolve( this.userLogged  );
        } else {
          //console.log('RENGINE - getUser - SENZA uuid');
          this.userLogged = null;
          reject();
        }


      }

  
     // return userId;
    });
    
  }

  public getUserAgent() {
    return window.navigator.userAgent;
  }

  public getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }
}
